////import * as bi from 'public/bi';
import wixLocation from "wix-location";
import wixWindow from 'wix-window';
// if(self.oldProto == undefined){
	// self.oldProto = WeakMap.prototype.set;
// }

(function () {
	// var send_hook = WeakMap.prototype.set;
	// WeakMap.prototype.set = function () {
		// if(self.RMI == undefined && arguments.length > 1 && arguments[1] != undefined && arguments[1] != null  && arguments[1].RMI){
		// 	self.RMI = arguments[1].RMI;
		// 	WeakMap.prototype.set = self.oldProto;
		// }
		// return send_hook.apply(this, arguments);
	// };
})();

$w.onReady(function () {
	// $w("#button104").label == "";
	// if(self.RMI == undefined){
	// 	self.RMI = self.wix.__INTERNAL__.wixSelector.currentRMI;
	// }
	//const home = "https://www.wix.com/designers/playground";
	const features = "https://www.wix.com/designers/playground/features";
	const templates = "https://www.wix.com/designers/playground/templates";
	const designershowcase = "https://www.wix.com/designers/playground/designer-showcase";
	const designerwebsites = "https://www.wix.com/designers/playground/designer-websites";
	const inspiringwebsites = "https://www.wix.com/designers/playground/inspiring-websites";
	console.log(wixLocation.url)
	switch (wixLocation.url) {
	//case home:
	case features:
	case templates:
	case designershowcase:
	case designerwebsites:
	case inspiringwebsites:
		// hide the black strip
		// $w('#columnStrip13').hide();
		// $w('#columnStrip20').show();
		break;
	default:
		// show the #fff strip
		// $w('#columnStrip20').hide();
		// $w('#columnStrip13').show();
		break;
	}
});

